<template>
  <div class="page-content-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-8">
          <tablaCertificado />
        </div>
        <div class="col-xl-4">
          <infoCertificado />
          <asignarCertificado />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tablaCertificado from "@/components/certificado/tablaCertificado";
import infoCertificado from "@/components/certificado/infoCertificado";
import asignarCertificado from "@/components/certificado/asignarCertificado";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    tablaCertificado,
    infoCertificado,
    asignarCertificado
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("alumno", ["jsonCoordinadora"])
  },
  methods: {
    ...mapActions("certificado", ["updateArrayCertificado"]),
    ...mapActions("alumno", ["updateJsonCoordinadora"]),
    async updateCoordinadora() {
      const { data: dataCertificado } = await this.axios.get("api/getCertificadosCoordinadora");
      const { certificados, programasAsociados } = dataCertificado;

      
      const listadoCertificados = certificados.map(elem => ({
        idCertificado: elem.idCertificado,
        nombreCertificado: elem.nombreCertificado,
        contenido: elem.contenido,
        urlHeader:elem.urlHeader,
        urlFooter:elem.urlFooter,
        curso: elem.cursos,
        estado: elem.activo
      }));

      this.updateArrayCertificado(listadoCertificados);

      //inicio privilegio
      // console.log(this.jsonCoordinadora);
      // const { data: userData } = await this.axios.get("api/getLoginLogeado");
      // const { usuarioDB: user } = userData;
      // const { data: dataCoordinadora } = await this.axios.get(`api/getCoordinadoraCampus`);

      // this.updateJsonCoordinadora({
      //   ...user,
      //   privilegios: dataCoordinadora.getPrivilegios
      // });

    }
  },
  created() {
    this.updateCoordinadora();
  }
};
</script>
